<p-dialog
    [(visible)]="visible"
    [header]="'service.settings.general.operationalCapacity.label' | translate"
    [baseZIndex]="2000"
>
    <div class="input-grid-gaps grid-4col gap">
        <app-date-input [form]="form" id="dateFrom"
            label="service.settings.general.operationalCapacity.fields.dateFrom"
        ></app-date-input>
        <app-date-input [form]="form" id="dateTo"
            label="service.settings.general.operationalCapacity.fields.dateTo"
        ></app-date-input>
        <app-select-input
            id="name"
            [form]="form"
            label="service.settings.general.operationalCapacity.fields.name"
            [staticOptions]="unitOptions()"
            valueKey="value">
        </app-select-input>
        <app-number-input [form]="form" id="amount"
            [label]="'service.settings.general.operationalCapacity.fields.amount' | translate"></app-number-input>
        <app-text-input class="fr-3" [form]="form" id="description"
            label="service.settings.general.operationalCapacity.fields.description"
        ></app-text-input>

        @if (store.isSocial()) {
            <app-select-input
                [form]="form"
                id="form"
                label="service.serviceFormEnum.label"
                [staticOptions]="store.formOptions()"
            ></app-select-input>
            <app-check-input
                [form]="form"
                id="fullWeekService"
                label="service.settings.general.operationalCapacity.fields.fullWeekService"
            ></app-check-input>
        }
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
